import React from "react";
import Card from "./Card";

function Cards({ user }) {
  const grouped = user.modules.reduce((acc, mod) => {
    const category = mod.category || "Uncategorized";
    if (!acc[category]) acc[category] = [];
    acc[category].push(mod);
    return acc;
  }, {});

  const preferredOrder = ["PEAK", "Pulse","AI", "ConnExa"];

  const sortedEntries = Object.entries(grouped).sort(([a], [b]) => {
    const aIndex = preferredOrder.indexOf(a);
    const bIndex = preferredOrder.indexOf(b);

    // Put preferred ones in order, rest keep alphabetical or default order
    if (aIndex !== -1 && bIndex !== -1) {
      return aIndex - bIndex;
    } else if (aIndex !== -1) {
      return -1;
    } else if (bIndex !== -1) {
      return 1;
    } else {
      return 0; // Keep other categories in original order
    }
  });

  return (
    <div
      className="absolute top-[65px] left-0 right-0 px-3 mx-3 space-y-4 overflow-y-auto"
      style={{ height: "calc(100vh - 120px)" }}
    >
      {sortedEntries.map(([category, modules]) => (
        <div key={category}>
          <h2 className="text-lg bg-[#F0F0EA] border border-[#D3D3C9] rounded-t-lg font-semibold px-2 py-1.5 text-[#333] w-40 text-center">
            {category}
          </h2>
          <div className="flex bg-[#F0F0EA] border border-[#D3D3C9] rounded-lg rounded-tl-none flex-wrap gap-4 px-3 py-2 shadow-sm">
            {modules.map((mod) => (
              <Card key={mod.id} val={mod} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

export default Cards;
